const FeaturedCars = () => (
    <section id="featured-cars" className="featured-cars">
        <div className="container">
            <div className="section-header">
                <p>checkout <span>the</span> featured cars</p>
                <h2>featured cars</h2>
            </div>
            <div className="featured-cars-content">
                <div className="row">
                    <div className="col-lg-3 col-md-4 col-sm-6">
                        <div className="single-featured-cars">
                            <div className="featured-img-box">
                                <div className="featured-cars-img">
                                    <img src="assets/images/featured-cars/fc1.png" alt="cars" />
                                </div>
                                <div className="featured-model-info">
                                    <p>
                                        model: 2017
                                        <span className="featured-mi-span"> 3100 mi</span> 
                                        <span className="featured-hp-span"> 240HP</span>
                                            automatic
                                    </p>
                                </div>
                            </div>
                            <div className="featured-cars-txt">
                                <h2><a href="#a">BMW 6-series gran coupe</a></h2>
                                <h3>$89,395</h3>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin placerat posuere elit quis lobortis.  
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6">
                        <div className="single-featured-cars">
                            <div className="featured-img-box">
                                <div className="featured-cars-img">
                                    <img src="assets/images/featured-cars/fc2.png" alt="cars" />
                                </div>
                                <div className="featured-model-info">
                                    <p>
                                        model: 2017
                                        <span className="featured-mi-span"> 3100 mi</span> 
                                        <span className="featured-hp-span"> 240HP</span>
                                            automatic
                                    </p>
                                </div>
                            </div>
                            <div className="featured-cars-txt">
                                <h2><a href="#b">chevrolet camaro <span>wmv20</span></a></h2>
                                <h3>$66,575</h3>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin placerat posuere elit quis lobortis.  
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6">
                        <div className="single-featured-cars">
                            <div className="featured-img-box">
                                <div className="featured-cars-img">
                                    <img src="assets/images/featured-cars/fc3.png" alt="cars" />
                                </div>
                                <div className="featured-model-info">
                                    <p>
                                        model: 2017
                                        <span className="featured-mi-span"> 3100 mi</span> 
                                        <span className="featured-hp-span"> 240HP</span>
                                            automatic
                                    </p>
                                </div>
                            </div>
                            <div className="featured-cars-txt">
                                <h2><a href="#c">lamborghini <span>v520</span></a></h2>
                                <h3>$125,250</h3>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin placerat posuere elit quis lobortis.  
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6">
                        <div className="single-featured-cars">
                            <div className="featured-img-box">
                                <div className="featured-cars-img">
                                    <img src="assets/images/featured-cars/fc4.png" alt="cars" />
                                </div>
                                <div className="featured-model-info">
                                    <p>
                                        model: 2017
                                        <span className="featured-mi-span"> 3100 mi</span> 
                                        <span className="featured-hp-span"> 240HP</span>
                                            automatic
                                    </p>
                                </div>
                            </div>
                            <div className="featured-cars-txt">
                                <h2><a href="#d">audi <span> a3</span> sedan</a></h2>
                                <h3>$95,500</h3>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin placerat posuere elit quis lobortis.  
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default FeaturedCars;